import React from 'react';
import QRCode from 'qrcode.react';
import { Button, Spin } from 'antd';
import { formatCurrency } from 'utils';
import { useTranslation } from 'react-i18next';

const QrScanCode = (props) => {
  const {
    qrCodeData,
    onPressChangeAmount,
    onPressRegenerateQr,
    timeLeft,
    loading,
  } = props;
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20,
        flexDirection: 'column',
      }}>
      <div
        style={{
          fontSize: '30px',
          padding: '10px',
          display: 'flex',
          justifyContent: 'center',
        }}>
        <span>RM</span>
        <span>{formatCurrency(qrCodeData.amount)}</span>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingTop: '20px',
          alignItems: 'center',
        }}>
        <div style={{ position: 'relative' }}>
          {loading && <Loading />}
          <QRCode value={JSON.stringify(qrCodeData)} size={300} />
        </div>
        <div style={{ fontSize: '20px', paddingTop: '15px' }}>
          {timeLeft > 0 ? (
            <div className='expried-in'>
              <span>{t('expiresIn')} </span>
              <span style={{ color: 'blue' }}>
                {String(parseInt(timeLeft / 60)).padStart(2, '0')} :{' '}
                {String(timeLeft % 60).padStart(2, '0')}
              </span>
            </div>
          ) : (
            <div
              className='show-expired'
              style={{
                color: 'red',
                fontSize: '20px',
                textTransform: 'uppercase',
              }}>
              <span>{t('qrCodeExpired')}</span>
            </div>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '20px',
            alignItems: 'center',
          }}>
          <Button
            block
            type='primary'
            onClick={onPressRegenerateQr}
            disabled={loading}>
            {t('regenerateQrCode')}
          </Button>
          <div style={{ height: 10 }} />
          <Button block onClick={onPressChangeAmount}>
            {t('changeAmount')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QrScanCode;

const Loading = () => (
  <>
    <div
      style={{
        position: 'absolute',
        backgroundColor: '#f0f2f5',
        width: '100%',
        height: '100%',
      }}
    />
    <Spin
      spinning
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    />
  </>
);
